<template>
  <v-row>
    <v-col md="2">
      <v-row justify="center">
        <v-col md="12">
          <v-card>
            <v-card-text class="text-center primary--text pb-0 headline"
              >Session Notes</v-card-text
            >
            <div v-if="campaign.SessionNotes">
              <v-hover
                v-for="SessionNote in sortedArray"
                :key="SessionNote.Name"
              >
                <template v-slot:default="{ hover }">
                  <v-card flat>
                    <v-card-subtitle class="text-center py-2">{{
                      SessionNote.Name
                    }}</v-card-subtitle>
                    <v-fade-transition>
                      <v-overlay v-if="hover" absolute color="#036358">
                        <v-btn
                          @click="EditNote(SessionNote.Name)"
                          class="primary"
                          >Edit</v-btn
                        >
                      </v-overlay>
                    </v-fade-transition>
                  </v-card>
                </template>
              </v-hover>
            </div>
          </v-card>
        </v-col>
        <NewSessionNote :SessionNotes="campaign.SessionNotes" />
      </v-row>
    </v-col>
    <v-col md="10">
      <v-row justify="center">
        <v-col md="3">
          <v-card>
            <v-card-title class="justify-center primary--text headline"
              >Towns</v-card-title
            >
            <PieChart
              v-if="loading.town"
              :data="[meta.town.Priavte, meta.town.Public]"
              :labels="['Private', 'Public']"
              class="px-4"
            />
            <v-card-subtitle class="text-center">
              Total Towns:
              <span class="secondary--text">{{
                meta.town.Priavte + meta.town.Public
              }}</span>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col md="3">
          <v-card>
            <v-card-title class="justify-center primary--text headline"
              >Shops</v-card-title
            >
            <PieChart
              v-if="loading.shop"
              :data="[meta.shop.Priavte, meta.shop.Public]"
              :labels="['Private', 'Public']"
              class="px-4"
            />
            <v-card-subtitle class="text-center">
              Total Shops:
              <span class="secondary--text">{{
                meta.shop.Priavte + meta.shop.Public
              }}</span>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col md="3">
          <v-card>
            <v-card-title class="justify-center primary--text headline"
              >NPCs</v-card-title
            >
            <PieChart
              v-if="loading.npc"
              :data="[meta.npc.Priavte, meta.npc.Public]"
              :labels="['Private', 'Public']"
              class="px-4"
            />
            <v-card-subtitle class="text-center">
              Total NPC:
              <span class="secondary--text">{{
                meta.npc.Priavte + meta.npc.Public
              }}</span>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col md="3">
          <v-card>
            <v-card-title class="justify-center primary--text headline"
              >Notes</v-card-title
            >
            <PieChart
              v-if="loading.note"
              :data="[meta.note.Priavte, meta.note.Public]"
              :labels="['Private', 'Public']"
              class="px-4"
            />
            <v-card-subtitle class="text-center">
              Total Notes:
              <span class="secondary--text">{{
                meta.note.Priavte + meta.note.Public
              }}</span>
            </v-card-subtitle>
          </v-card>
        </v-col>

        <v-col md="12">
          <v-card>
            <v-card-title class="justify-center primary--text headline">
              <v-row>
                <v-spacer></v-spacer>
                <v-col md="1" class="px-0">
                  General Info
                </v-col>
                <v-spacer></v-spacer>
                <v-col md="2" class="px-8">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="secondary"
                          @click="editDialog = true"
                          v-on="on"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit Campaign</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="ml-2"
                          color="red darken-1"
                          dark
                          @click="deleteDialog = true"
                          v-on="on"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete Campaign</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col md="12">
          <v-card>
            <v-card-title class="justify-center primary--text headline pb-0">
              <v-row>
                <v-spacer></v-spacer>
                <v-col md="1" class="px-0">
                  Saved Tags
                </v-col>
                <v-spacer></v-spacer>
                <v-col md="2" class="px-8"> </v-col>
              </v-row>
            </v-card-title>
            <v-chip
              v-for="(tag, index) in campaign.Tags"
              :key="index"
              class="mb-6 ml-3"
              close
              :color="'#' + Math.floor(Math.random() * 16777215).toString(16)"
              text-color="white"
              @click:close="removeChip(index)"
            >
              {{ tag }}
            </v-chip>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog
      v-model="editDialog"
      transition="dialog-bottom-transition"
      max-width="600px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Campaign</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="UpdateCampaign()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form ref="Note" class="pa-3">
          <v-text-field
            v-model="TempCampaign.Name"
            label="Title"
            outlined
          ></v-text-field>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showEditNote"
      transition="dialog-bottom-transition"
      max-width="600px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showEditNote = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Note</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="UpdateNote()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form ref="Note" class="pa-3">
          <v-text-field
            v-model="TempNotes.Name"
            label="Title"
            outlined
          ></v-text-field>
          <v-textarea
            auto-grow
            outlined
            label="Note"
            v-model="TempNotes.Note"
          ></v-textarea>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="490">
      <v-card>
        <v-card-title class="headline"
          >Delete {{ campaign.Name }}?</v-card-title
        >
        <v-card-text>
          If you click Delete {{ campaign.Name }} will be removed for ever. This
          includes {{ meta.town.Priavte + meta.town.Public }} Towns,
          {{ meta.shop.Priavte + meta.shop.Public }} Shops,
          {{ meta.npc.Priavte + meta.npc.Public }} NPCs, and
          {{ meta.note.Priavte + meta.note.Public }} Notes.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" text @click="DeleteCampaign()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snackbar for error when trying to delete -->
    <v-snackbar top v-model="snackbar">
      {{ snacktext }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";
import { store } from "@/fb";

import PieChart from "@/components/PieChart";
import NewSessionNote from "@/components/NewSessionNote";

export default {
  components: { PieChart, NewSessionNote },
  name: "NPCs",
  data: () => ({
    campaign: { SessionNotes: [{ Name: null, Note: null }] },
    TempCampaign: {},
    newCampaign: {},
    dialog: false,
    deleteDialog: false,
    editDialog: false,
    meta: {
      npc: {},
      town: {},
      note: {},
      shop: {}
    },
    loading: {
      npc: false,
      town: false,
      note: false,
      shop: false
    },
    TempNotes: {},
    showEditNote: false,
    note: {},
    snackbar: false,
    snacktext: "You can't delete your only campaign"
  }),
  firestore() {
    this.$bind(
      "npcs",
      db
        .collection("npcs")
        .where("CampaignId", "==", store.CurrentCampaign.id)
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
    ).then((data) => {
      this.meta.npc.Priavte = data.filter((npc) => npc.Public != true).length;
      this.meta.npc.Public = data.length - this.meta.npc.Priavte;
      this.loading.npc = true;
    });
    this.$bind(
      "towns",
      db
        .collection("towns")
        .where("CampaignId", "==", store.CurrentCampaign.id)
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
    ).then((data) => {
      this.meta.town.Priavte = data.filter((npc) => npc.Public != true).length;
      this.meta.town.Public = data.length - this.meta.town.Priavte;
      this.loading.town = true;
    });
    this.$bind(
      "notes",
      db
        .collection("notes")
        .where("CampaignId", "==", store.CurrentCampaign.id)
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
    ).then((data) => {
      this.meta.note.Priavte = data.filter((npc) => npc.Public != true).length;
      this.meta.note.Public = data.length - this.meta.note.Priavte;
      this.loading.note = true;
    });
    this.$bind(
      "shops",
      db
        .collection("shops")
        .where("CampaignId", "==", store.CurrentCampaign.id)
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
    ).then((data) => {
      this.meta.shop.Priavte = data.filter((npc) => npc.Public != true).length;
      this.meta.shop.Public = data.length - this.meta.shop.Priavte;
      this.loading.shop = true;
    });
    this.$bind(
      "campaign",
      db.collection("campaigns").doc(store.CurrentCampaign.id)
    ).then((data) => {
      this.TempCampaign.Name = data.Name;
    });
  },
  computed: {
    sortedArray: function() {
      function compare(a, b) {
        if (a.Name < b.Name) return 1;
        if (a.Name > b.Name) return -1;
        return 0;
      }

      return [...this.campaign.SessionNotes].sort(compare);
    }
  },
  methods: {
    removeChip(index) {
      this.campaign.Tags.splice(index, 1);
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Tags: this.campaign.Tags });
    },
    EditNote(name) {
      this.TempNotes = this.campaign.SessionNotes.find(
        ({ Name }) => Name === name
      );
      this.note.index = this.campaign.SessionNotes.findIndex(
        ({ Name }) => Name === name
      );
      this.showEditNote = true;
    },
    UpdateNote() {
      this.campaign.SessionNotes[this.note.index] = this.TempNotes;
      this.showEditNote = false;
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ SessionNotes: this.campaign.SessionNotes });
    },

    UpdateCampaign() {
      store.CurrentCampaign.Name = this.TempCampaign.Name;
      this.editDialog = false;
      this.campaign.Name = this.TempCampaign.Name;
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Name: this.TempCampaign.Name });
      db.collection("users")
        .doc(this.playerid)
        .update({
          CurrentCampaign: { ...this.campaign, id: store.CurrentCampaign.id }
        })
        .then(() => {
          this.$router.go(0);
        });
    },

    DeleteCampaign() {
      db.collection("campaigns")
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snap) => {
          if (snap.size === 1) {
            this.snackbar = true;
          } else {
            let i = 0;
            if (snap.docs[i].id === store.CurrentCampaign.id) {
              i++;
            }
            var NPCs = db
              .collection("npcs")
              .where("CampaignId", "==", this.campaign.id);
            NPCs.get().then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                doc.ref.delete();
              });
            });
            var Towns = db
              .collection("towns")
              .where("CampaignId", "==", this.campaign.id);
            Towns.get().then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                doc.ref.delete();
              });
            });
            var Shops = db
              .collection("shops")
              .where("CampaignId", "==", this.campaign.id);
            Shops.get().then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                doc.ref.delete();
              });
            });
            var Notes = db
              .collection("notes")
              .where("CampaignId", "==", this.campaign.id);
            Notes.get().then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                doc.ref.delete();
              });
            });
            console.log(snap.docs[i].id);
            console.log(this.playerid);
            db.collection("users")
              .doc(firebase.auth().currentUser.uid)
              .update({
                CurrentCampaign: {
                  ...snap.docs[i].data(),
                  id: snap.docs[i].id
                }
              })
              .then(() => {
                db.collection("campaigns")
                  .doc(store.CurrentCampaign.id)
                  .delete();
                this.$router.go(0);
              });
          }
        });
    }
  }
};
</script>
